document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("product_loader").classList.add("loading");
  // **State object to manage selected values**
  const state = {
    width: 3,
    height: 3,
    material: 0,
    quantity_variable: 100,
    greater_dimension: 3,
    discounts: {},
  };

  // **Disounts Data**
  fetch(window.printCustomLabelsDiscount)
    .then((response) => response.json())
    .then((data) => {
      state.discounts = data["Glitter Labels"];
    })
    .catch((error) => console.error("Error loading JSON:", error));

  // **Materials Data**
  fetch(window.printCustomLabelsMaterials)
    .then((response) => response.json())
    .then((data) => {
      state.material = data["Glitter Labels"];
    })
    .catch((error) => console.error("Error loading JSON:", error));

  // **Function to determine greater dimension for discounts**
  function greaterDimension(w, h) {
    const rw = Math.round(w);
    const rh = Math.round(h);
    return Math.min(Math.max(rw, rh), 8);
  }

  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;

      targetElement.textContent = currentValue.toFixed(2);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function calculateDiscount(quantity) {
    if (quantity < 10) {
      return 10;
    }

    // Adjust the quantity to the nearest discount tier
    if (quantity >= 10 && quantity < 50) {
      return 10;
    } else if (quantity >= 50 && quantity < 100) {
      return 50;
    } else if (quantity >= 100 && quantity < 200) {
      return 100;
    } else if (quantity >= 200 && quantity < 300) {
      return 200;
    } else if (quantity >= 300 && quantity < 500) {
      return 300;
    } else if (quantity >= 500 && quantity < 800) {
      return 500;
    } else if (quantity >= 800 && quantity < 1000) {
      return 800;
    } else if (quantity >= 1000 && quantity < 1500) {
      return 1000;
    } else if (quantity >= 1500 && quantity < 2000) {
      return 1500;
    } else if (quantity >= 2000 && quantity < 5000) {
      return 2000;
    } else {
      return 5000;
    }
  }

  function calculatePrice(s, q, d) {
    const materialPrice = state.material;

    // **Calculate the final price**
    let finalPrice = s * q * materialPrice * d;
    let noDiscountPrice = s * q * materialPrice;

    if (finalPrice < 25) {
      finalPrice = 25;
    }

    // **Get the target price element**
    const priceElement = document.querySelector("#pcs-final-price");
    const cutoffPriceElement = document.querySelector("#pcs-cutoff-price");
    const cutoffPriceBlock = document.querySelector(
      ".pcs-price__ticker.cutoff-price"
    );
    const artworkPriceElement = document.querySelector("#price-artwork");

    if (cutoffPriceElement) {
      if (d === 1) {
        cutoffPriceBlock.style.display = "none";
      } else if (d < 1) {
        cutoffPriceBlock.style.display = "block";
        const currentPrice = parseFloat(cutoffPriceElement.textContent) || 0;
        animatePriceChange(cutoffPriceElement, currentPrice, noDiscountPrice);
      }
    }

    if (priceElement) {
      const currentPrice = parseFloat(priceElement.textContent) || 0;

      // **Apply counter effect**
      animatePriceChange(priceElement, currentPrice, finalPrice);
    }

    if (artworkPriceElement)
      animatePriceChange(
        artworkPriceElement,
        parseFloat(artworkPriceElement.textContent) || 0,
        finalPrice
      );
  }

  // **Function to safely update calculator values**
  function updateCalculator() {
    const calculator = document.querySelector("#calculator");
    if (!calculator) return;

    const cutlineTextarea = calculator.querySelector(
      "textarea[name='properties[Cutline]']"
    );
    const defaultShape =
      document.querySelector(".sticker-variant.active")?.dataset.shape ||
      "Contour-Cut";

    if (cutlineTextarea) {
      cutlineTextarea.value = defaultShape;
    }

    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");

    if (fileInput) {
      fileInput.setAttribute(
        "accept",
        ".ai,.eps,.jpg,.jpeg,.png,.pdf,.tiff,.svg"
      );
    }

    const adjustedQuantity = calculateDiscount(state.quantity_variable);
    const discount =
      state.discounts?.[state.greater_dimension]?.[adjustedQuantity] ?? 0;
    const discountMultiplier = (100 - discount) / 100;

    const quantity = state.quantity_variable || 0;
    const size = state.width && state.height ? state.width * state.height : 0;

    // **Update form values**
    calculator.querySelector("input[name='properties[Discount]']").value =
      discountMultiplier;
    calculator.querySelector("input[name='properties[Quantity]']").value =
      quantity;
    calculator.querySelector("select[name='properties[Material]']").value =
      "Glitter Labels";
    calculator.querySelector("input[name='properties[Width]']").value =
      state.width || "";
    calculator.querySelector("input[name='properties[Height]']").value =
      state.height || "";

    // **Update Artwork Details**
    document.querySelector("#shape-artwork").textContent =
      calculator.querySelector("textarea[name='properties[Cutline]']").value;
    document.querySelector("#width-artwork").textContent = state.width || "0";
    document.querySelector("#height-artwork").textContent = state.height || "0";
    document.querySelector("#quantity-artwork").textContent = quantity || "0";

    renderQuantityOptions();
    calculatePrice(size, quantity, discountMultiplier);
    safePriceUpdation();
  }

  // **Ensures priceUpdation() runs when available**
  function safePriceUpdation() {
    if (typeof window.PriceUpdation === "function") {
      window.PriceUpdation();
    } else {
      console.warn("⚠️ PriceUpdation function not available. Retrying...");
      let retry = setInterval(() => {
        if (typeof window.PriceUpdation === "function") {
          clearInterval(retry);
          console.log("✅ PriceUpdation function found. Executing...");
          window.PriceUpdation();
        }
      }, 500);
    }
  }

  // **Event Listener: Shape Selection**
  function setupShapeSelection() {
    document.addEventListener("click", function (event) {
      const selectedVariant = event.target.closest(
        "#shape-variant .sticker-variant"
      );

      if (selectedVariant) {
        // Remove active class only from shape variants
        document
          .querySelectorAll("#shape-variant .sticker-variant")
          .forEach((el) => el.classList.remove("active"));

        selectedVariant.classList.add("active");

        const calculator = document.querySelector("#calculator");
        const shapeArtwork = document.querySelector("#shape-artwork");
        if (calculator) {
          const cutlineTextarea = calculator.querySelector(
            "textarea[name='properties[Cutline]']"
          );
          if (cutlineTextarea) {
            cutlineTextarea.value = selectedVariant.dataset.shape;
          }
        }

        if (shapeArtwork) {
          shapeArtwork.textContent = selectedVariant.dataset.shape;
        }
      }
    });
  }

  // **Event Listener: Size Selection**
  function renderSizeOptions() {
    const sizeContainer = document.querySelector(".size-items");
    const customWidth = document.getElementById("custom-width");
    const customHeight = document.getElementById("custom-height");
    const customSizeWrapper = document.getElementById("custom-size-input");
    const sizeErrorBar = document.getElementById("size-error-bar");

    if (!sizeContainer) return;

    const sizes = [
      { label: '1" x 1"', width: 1, height: 1 },
      { label: '2" x 1"', width: 2, height: 1 },
      { label: '2" x 2"', width: 2, height: 2 },
      { label: '3" x 2"', width: 3, height: 2 },
      { label: '3" x 3"', width: 3, height: 3 },
      { label: '4" x 3"', width: 4, height: 3 },
      { label: '4" x 4"', width: 4, height: 4 },
      { label: '5" x 2"', width: 5, height: 2 },
      { label: '5" x 3"', width: 5, height: 3 },
      { label: '5" x 5"', width: 5, height: 5 },
    ];

    sizeContainer.innerHTML = ""; // Clear previous items

    sizes.forEach(({ label, width, height }) => {
      const item = document.createElement("div");
      item.className = "size-item";
      item.dataset.width = width;
      item.dataset.height = height;
      item.textContent = label;

      // Apply 'active' class if this size is selected
      if (state.width === width && state.height === height) {
        item.classList.add("active");
      }

      item.addEventListener("click", () => {
        // Clear custom size fields
        customWidth.value = "";
        customHeight.value = "";

        customWidth.classList.remove("error-field", "filled");
        customHeight.classList.remove("error-field", "filled");
        sizeErrorBar.classList.remove("active");
        customSizeWrapper.classList.remove("variant-picked");

        // Update state
        state.width = width;
        state.height = height;
        state.greater_dimension = greaterDimension(width, height);

        // Toggle active classes
        document
          .querySelectorAll(".size-item")
          .forEach((el) => el.classList.remove("active"));
        item.classList.add("active");

        renderQuantityOptions();
        updateCalculator();
      });

      sizeContainer.appendChild(item);
    });

    // Custom input logic
    [customWidth, customHeight].forEach((input) => {
      input.addEventListener("input", function () {
        // Remove all active size blocks
        document
          .querySelectorAll(".size-item")
          .forEach((el) => el.classList.remove("active"));

        // Update state
        state.width = customWidth.value ? parseFloat(customWidth.value) : null;
        state.height = customHeight.value
          ? parseFloat(customHeight.value)
          : null;
        state.greater_dimension = greaterDimension(
          state.width || 0,
          state.height || 0
        );

        renderQuantityOptions();
        updateCalculator();

        // Clear validation error if field has value
        if (input.value.trim() !== "") {
          input.classList.remove("error-field");
        }

        const isWidthFilled = customWidth.value.trim() !== "";
        const isHeightFilled = customHeight.value.trim() !== "";

        if (isWidthFilled && isHeightFilled) {
          customSizeWrapper.classList.add("variant-picked");
          sizeErrorBar.classList.remove("active");
        } else {
          customSizeWrapper.classList.remove("variant-picked");
        }

        customWidth.classList.toggle("filled", isWidthFilled);
        customHeight.classList.toggle("filled", isHeightFilled);
      });
    });
  }

  function renderQuantityOptions() {
    const quantityContainer = document.querySelector(".quantity-items");
    if (!quantityContainer) return;

    const pieces = [50, 100, 200, 300, 500, 800, 1000, 1500, 2000, 5000];
    const materialRate = state.material;
    const width = state.width || 3;
    const height = state.height || 3;
    const area = width * height;
    const sizeIndex = greaterDimension(width, height);

    quantityContainer.innerHTML = ""; // Clear existing

    pieces.forEach((qty) => {
      const discount = state.discounts?.[sizeIndex]?.[qty] ?? 0;
      const discountMultiplier = (100 - discount) / 100;

      let fullPrice = area * qty * materialRate;
      let finalPrice = fullPrice * discountMultiplier;

      if (finalPrice < 25) finalPrice = 25;

      const discountText = discount > 0 ? `Save ${Math.round(discount)}%` : "";

      const item = document.createElement("div");
      item.className = "quantity-item";
      item.dataset.quantity = qty;

      // Add 'active' class if this is the selected one
      if (qty === state.quantity_variable) {
        item.classList.add("active");
      }

      // Build inner HTML dynamically
      let itemHTML = `
        <p class="pieces">${qty} pcs</p>
        <p class="price">$${finalPrice.toFixed(2)}</p>`;

      if (discount > 0) {
        itemHTML += `<p class="discount">Save ${Math.round(discount)}%</p>`;
      }

      item.innerHTML = itemHTML;

      // Handle quantity click
      item.addEventListener("click", () => selectQuantity(qty));

      quantityContainer.appendChild(item);
    });
  }

  function selectQuantity(qty) {
    const quantityPriceBox = document.querySelector(".quantity-price-box");
    const customInput = document.getElementById("custom-quantity");
    const quantityErrorBar = document.getElementById("quantity-error-bar");
    state.quantity_variable = qty;
    document.getElementById("custom-quantity").value = "";

    // Reset error visuals
    customInput.classList.remove("filled");
    customInput.classList.remove("error-field");
    quantityErrorBar.classList.remove("active");

    // Update active visual
    document
      .querySelectorAll(".quantity-item")
      .forEach((el) => el.classList.remove("active"));

    const selected = document.querySelector(
      `.quantity-item[data-quantity="${qty}"]`
    );
    if (selected) selected.classList.add("active");

    quantityPriceBox.classList.add("variant-picked");

    // Update quantity in form
    const quantityInput = document.querySelector(
      "input[name='properties[Quantity]']"
    );
    if (quantityInput) quantityInput.value = qty;

    const artworkQty = document.querySelector("#quantity-artwork");
    if (artworkQty) artworkQty.textContent = qty;

    updateCalculator(); // Only price & discount update
  }

  function setupCustomQuantityInput() {
    const quantityPriceBox = document.querySelector(".quantity-price-box");
    const customInput = document.getElementById("custom-quantity");
    const quantityErrorBar = document.getElementById("quantity-error-bar");

    if (!customInput) return;

    customInput.addEventListener("input", () => {
      const value = parseInt(customInput.value);

      // Remove active states from predefined quantity items
      document
        .querySelectorAll(".quantity-item")
        .forEach((el) => el.classList.remove("active"));
      quantityPriceBox.classList.remove("variant-picked");

      // Reset error visuals
      customInput.classList.remove("error-field");
      quantityErrorBar.classList.remove("active");
      customInput.classList.add("filled");

      // Handle empty or invalid input
      if (isNaN(value) || value <= 0) {
        state.quantity_variable = 0;
        return;
      }

      // Update state and UI
      state.quantity_variable = value;

      // Update quantity in form and artwork
      const quantityInput = document.querySelector(
        "input[name='properties[Quantity]']"
      );
      if (quantityInput) quantityInput.value = value;

      const artworkQty = document.querySelector("#quantity-artwork");
      if (artworkQty) artworkQty.textContent = value;

      // Recalculate pricing
      updateCalculator();
    });
  }

  function uploadArtwork() {
    // **Get necessary elements**
    const uploadArtworkBtn = document.getElementById("upload-artwork-btn");
    const uploadArtworkSection = document.getElementById("upload-artwork");
    const customFieldsSection = document.getElementById("pcs-custom-fields");
    const backToEditorBtn = document.getElementById("back-to-editor");
    const chooseFileBtn = document.getElementById("choose-file-btn");
    const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
    const filePath = document.getElementById("file-path");
    const filePathDisplay = document.querySelector("#file-path p");
    const designProofCheckbox = document.getElementById(
      "design-proof-checkbox"
    );
    const designProof = document.getElementById("design-proof");
    const fileInstructionsBox = document.getElementById(
      "file-instructions-box"
    );
    const fileInstructionsInput = document.getElementById("file-instructions");
    const pcs_add_to_cart = document.getElementById("pcs-add-to-cart");
    const product_loader = document.getElementById("product_loader");
    const uploadFileBox = document.querySelector(".upload-file-box");
    const laterOption = document.querySelector(".later-option");
    const emailLaterCheckbox = document.getElementById("email-later");
    const instructionsBox = document.getElementById("instructions-box");
    const instructionsInput = document.getElementById("instructions");

    const sizeSelect = document.getElementById("size-select");
    const quantitySelect = document.getElementById("quantity-select");
    const customWidth = document.getElementById("custom-width");
    const customHeight = document.getElementById("custom-height");
    const customQuantityInput = document.getElementById("custom-quantity");
    const sizeErrorBar = document.getElementById("size-error-bar");
    const quantityErrorBar = document.getElementById("quantity-error-bar");
    const calculator = document.getElementById("calculator");

    // **Function to validate custom fields**
    function validateCustomFields() {
      let firstEmptyField = null;

      // Reset previous error highlights
      [customWidth, customHeight, customQuantityInput].forEach((field) => {
        field.classList.remove("error-field");
        sizeErrorBar.classList.remove("active");
        quantityErrorBar.classList.remove("active");
      });

      // If Custom Size is selected, check width & height fields
      const noSizePresetSelected = !document.querySelector(".size-item.active");
      const isWidthEmpty = !customWidth.value.trim();
      const isHeightEmpty = !customHeight.value.trim();

      if (noSizePresetSelected && (isWidthEmpty || isHeightEmpty)) {
        if (isWidthEmpty) {
          customWidth.classList.add("error-field");
          sizeErrorBar.classList.add("active");
          firstEmptyField = firstEmptyField || customWidth;
        }

        if (isHeightEmpty) {
          customHeight.classList.add("error-field");
          sizeErrorBar.classList.add("active");
          firstEmptyField = firstEmptyField || customHeight;
        }
      }

      // If Custom Quantity is selected, check quantity field
      const isCustomQuantityEmpty = !customQuantityInput.value.trim();
      const isAnyPresetSelected = document.querySelector(
        ".quantity-item.active"
      );

      if (!isAnyPresetSelected && isCustomQuantityEmpty) {
        customQuantityInput.classList.add("error-field");
        quantityErrorBar.classList.add("active");
        firstEmptyField = firstEmptyField || customQuantityInput;
      }

      // If any required field is empty, scroll to it and return false
      if (firstEmptyField) {
        const fieldRect = firstEmptyField.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const scrollY =
          window.scrollY +
          fieldRect.top -
          (windowHeight - fieldRect.height) / 2;

        window.scrollTo({ top: scrollY, behavior: "smooth" });
        return false;
      }

      return true;
    }

    window.addEventListener("click", function (event) {
      if (
        event.target !== customWidth &&
        event.target !== customHeight &&
        event.target !== customQuantityInput
      ) {
        if (!validateCustomFields()) {
          validateCustomFields();
        }
      }
    });

    // **Function to toggle visibility with smooth transition**
    function toggleVisibility(showElement, hideElement) {
      if (hideElement) {
        hideElement.style.opacity = "0";
        setTimeout(() => {
          hideElement.style.display = "none";
          if (showElement) {
            showElement.style.display = "block";
            setTimeout(() => {
              showElement.style.opacity = "1";
            }, 50);
          }
        }, 300);
      }
    }

    // **Show Upload Artwork Section**
    if (uploadArtworkBtn) {
      uploadArtworkBtn.addEventListener("click", () => {
        if (!validateCustomFields()) return;

        const artworkBox = document.querySelector(".artwork-box");
        window.scrollTo({ top: 0, behavior: "smooth" });
        toggleVisibility(uploadArtworkSection, customFieldsSection);

        setTimeout(() => {
          if (artworkBox) {
            const boxRect = artworkBox.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const scrollY =
              window.scrollY +
              boxRect.top -
              (windowHeight - boxRect.height) / 2;

            window.scrollTo({ top: scrollY, behavior: "smooth" });
          }
        }, 300); // Delay to ensure visibility transition

        // Blink border utility
        function blinkElement(
          element,
          className = "blink-border",
          blinks = 4,
          interval = 200
        ) {
          if (!element) return;

          for (let i = 0; i < blinks * 2; i++) {
            setTimeout(() => {
              element.classList.toggle(className);
            }, i * interval);
          }
        }

        // Usage
        blinkElement(artworkBox);
      });
    }

    // **Back to Editor Functionality**
    if (backToEditorBtn) {
      backToEditorBtn.addEventListener("click", () => {
        toggleVisibility(customFieldsSection, uploadArtworkSection);
      });
    }

    function updateButtonState() {
      // Disable Add to Cart button if neither option is selected
      if (!fileInput.files.length && !emailLaterCheckbox.checked) {
        pcs_add_to_cart.disabled = true;
      } else {
        pcs_add_to_cart.disabled = false;
        setTimeout((e) => {
          pcs_add_to_cart.classList.add("shine");
        }, 1000);
        setTimeout((e) => {
          pcs_add_to_cart.classList.remove("shine");
        }, 2000);
      }
    }

    // **Trigger File Input Dialog**
    if (chooseFileBtn && fileInput) {
      chooseFileBtn.addEventListener("click", () => {
        fileInput.click();
      });

      // **Update File Name in UI**
      fileInput.addEventListener("change", (event) => {
        if (event.target.files.length > 0) {
          filePath.style.display = "block";
          laterOption.classList.add("dim--block");
          uploadFileBox.classList.remove("dim--block");
          designProofCheckbox.style.display = "flex";
          fileInstructionsBox.classList.add("active");
          const file = event.target.files[0];
          if (file) {
            const fullName = file.name;
            if (fullName.length > 30) {
              const start = fullName.slice(0, 8);
              const end = fullName.slice(-9); // You can adjust this
              filePathDisplay.textContent = `${start}....${end}`;
            } else {
              filePathDisplay.textContent = fullName;
            }
          }

          emailLaterCheckbox.checked = false;
          instructionsBox.classList.remove("active");
          if (calculator) {
            calculator.querySelector(
              "textarea[name='properties[No Image]']"
            ).value = null;
          }
        } else {
          filePath.style.display = "none";
          designProofCheckbox.style.display = "none";
          fileInstructionsBox.classList.remove("active");
        }

        updateButtonState();

        if (window.innerWidth <= 768 && pcs_add_to_cart) {
          setTimeout(() => {
            const rect = pcs_add_to_cart.getBoundingClientRect();
            const scrollY =
              window.scrollY +
              rect.top -
              (window.innerHeight - rect.height) / 2;
            window.scrollTo({ top: scrollY, behavior: "smooth" });
          }, 300);
        }
      });
    }

    designProof.addEventListener("change", (e) => {
      if (calculator) {
        calculator.querySelector(
          "input.checkbox[name='properties[Design Proof Before Shipping ]']"
        ).checked = e.target.checked;
      }
    });

    if (instructionsInput && calculator) {
      instructionsInput.addEventListener("input", function () {
        calculator.querySelector(
          "textarea[name='properties[Instructions]']"
        ).value = instructionsInput.value;

        fileInstructionsInput.value = instructionsInput.value;
      });
    }

    if (fileInstructionsInput && calculator) {
      fileInstructionsInput.addEventListener("input", function () {
        calculator.querySelector(
          "textarea[name='properties[Instructions]']"
        ).value = fileInstructionsInput.value;

        instructionsInput.value = fileInstructionsInput.value;
      });
    }

    emailLaterCheckbox.addEventListener("change", function () {
      if (emailLaterCheckbox.checked) {
        // Reset the uploaded file
        fileInput.value = "";
        filePath.style.display = "none";
        laterOption.classList.remove("dim--block");
        uploadFileBox.classList.add("dim--block");
        designProofCheckbox.style.display = "none";
        designProof.checked = false;
        fileInstructionsBox.classList.remove("active");
        instructionsBox.classList.add("active");

        if (calculator) {
          calculator.querySelector(
            "textarea[name='properties[No Image]']"
          ).value = "Request an image from the client.";

          calculator.querySelector(
            "input.checkbox[name='properties[Design Proof Before Shipping ]']"
          ).checked = false;
        }
      } else {
        instructionsBox.classList.remove("active");

        if (calculator) {
          calculator.querySelector(
            "textarea[name='properties[No Image]']"
          ).value = null;
        }
      }
      updateButtonState();
    });

    // pcs_add_to_cart.addEventListener("click", (e) => {
    //   pcs_add_to_cart.classList.add("loading");
    //   pcs_add_to_cart.disabled = true;
    //   pcs_add_to_cart.innerHTML = `Adding to Cart <div class="dot-falling"></div>`;
    //   document.getElementById("AddToCart").click();
    // });

    updateButtonState();
  }

  function typeText(el, text, speed = 60) {
    return new Promise((resolve) => {
      let i = 0;
      const typeInterval = setInterval(() => {
        el.textContent += text[i];
        i++;
        if (i >= text.length) {
          clearInterval(typeInterval);
          resolve();
        }
      }, speed);
    });
  }

  function deleteText(el, speed = 40) {
    return new Promise((resolve) => {
      const delInterval = setInterval(() => {
        el.textContent = el.textContent.slice(0, -1);
        if (el.textContent.length === 0) {
          clearInterval(delInterval);
          resolve();
        }
      }, speed);
    });
  }

  function resetCalculatorForm() {
    const form = document.querySelector("#calculator");
    if (!form) return;

    // Reset all input/select/textarea values
    form.querySelectorAll("input, select, textarea").forEach((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false;
      } else if (input.type === "file") {
        input.value = "";
      } else {
        input.value = "";
      }
    });

    // Default shape: Diecut
    document.querySelectorAll(".sticker-variant").forEach((el) => {
      el.classList.remove("active");
    });
    const defaultShape = document.querySelector(
      ".sticker-variant[data-shape='Diecut']"
    );
    if (defaultShape) defaultShape.classList.add("active");
    const shapeInput = document.getElementById("selected-shape");
    if (shapeInput) shapeInput.value = "Diecut";

    // Default size: 3x3
    document.querySelectorAll(".size-item").forEach((el) => {
      el.classList.remove("active");
    });
    const defaultSize = document.querySelector(
      '.size-item[data-width="3"][data-height="3"]'
    );
    if (defaultSize) defaultSize.classList.add("active");

    document.getElementById("custom-width").value = "";
    document.getElementById("custom-height").value = "";
    document
      .getElementById("custom-size-input")
      .classList.remove("variant-picked");

    // Default quantity: 100pcs
    if (typeof selectQuantity === "function") {
      selectQuantity(100);
    }
    document.getElementById("custom-quantity").value = "";
    document
      .querySelector(".quantity-price-box")
      ?.classList.add("variant-picked");

    // Clear artwork file and related UI
    document.getElementById("file-path")?.style.setProperty("display", "none");
    const fileNameDisplay = document.querySelector("#file-path p");
    if (fileNameDisplay) fileNameDisplay.textContent = "";
    document.querySelector(".calc-prop.cpc-file-upload").value = "";
    document.getElementById("email-later").checked = false;
    document.getElementById("design-proof").checked = false;
    document.getElementById("file-instructions").value = "";
    document.getElementById("instructions").value = "";

    // Remove shine or dim effects
    document.querySelector(".later-option")?.classList.add("dim--block");
    document.querySelector(".upload-file-box")?.classList.remove("dim--block");
    document
      .getElementById("file-instructions-box")
      ?.classList.remove("active");
    document.getElementById("instructions-box")?.classList.remove("active");
    document
      .getElementById("design-proof-checkbox")
      ?.style.setProperty("display", "none");
    document.getElementById("pcs-add-to-cart").disabled = true;

    // Hide error bars
    document.getElementById("size-error-bar")?.classList.remove("active");
    document.getElementById("quantity-error-bar")?.classList.remove("active");

    // Update price UI
    document.getElementById("pcs-final-price").textContent = "0.00";
    document.getElementById("pcs-cutoff-price").textContent = "0.00";

    // Reset artwork preview values
    document.getElementById("shape-artwork").textContent = "Diecut";
    document.getElementById("width-artwork").textContent = "3";
    document.getElementById("height-artwork").textContent = "3";
    document.getElementById("quantity-artwork").textContent = "100";

    // Update form input values directly
    const discountInput = form.querySelector(
      "input[name='properties[Discount]']"
    );
    if (discountInput) discountInput.value = "";

    form.querySelector("input[name='properties[Width]']").value = "3";
    form.querySelector("input[name='properties[Height]']").value = "3";
    form.querySelector("input[name='properties[Quantity]']").value = "100";
    form.querySelector("textarea[name='properties[Cutline]']").value = "Diecut";
    form.querySelector("select[name='properties[Material]']").value =
      "Glitter Labels";

    if (typeof state !== "undefined") {
      state.quantity_variable = 100;
      state.width = 3;
      state.height = 3;
      state.greater_dimension = 3;
    }

    // Optionally rerun calculator logic
    if (typeof updateCalculator === "function") {
      updateCalculator();
    }

    console.log("Last", document.querySelector(".quantity-item.active"));
  }

  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("pcs-add-to-cart");
    if (!addToCartBtn) return;

    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = `
  <div class="pcs-loader"></div>
  <p class="pcs-message"></p>
  <div class="dot-falling"></div>
`;

      const messageEl = addToCartBtn.querySelector(".pcs-message");

      // Looping text messages
      const messages = ["Adding to cart", "GETTING THINGS READY"];
      let messageIndex = 0;
      let stopTypingLoop = false;

      const startTypingLoop = async () => {
        while (!stopTypingLoop) {
          const message = messages[messageIndex % messages.length];
          await typeText(messageEl, message);
          await new Promise((resolve) => setTimeout(resolve, 2000)); // pause after typing
          await deleteText(messageEl);
          messageIndex++;
        }
      };

      // Start the typing loop
      startTypingLoop();

      const loadingBar = addToCartBtn.querySelector(".pcs-loader");

      let progress = 0;
      const target = 99;

      const interval = setInterval(() => {
        if (progress < 50) {
          progress += 2; // Fast start
        } else if (progress < 80) {
          progress += (80 - progress) * 0.05; // Medium speed
        } else if (progress < target - 0.2) {
          progress += (target - progress) * 0.05; // Slowest easing near end
        } else {
          progress = target - 0.01;
          clearInterval(interval);
        }

        loadingBar.style.transform = `scaleX(${Math.floor(progress)}%)`;
      }, 80);

      const productId = document.querySelector(
        "input[name='product-id']"
      ).value;
      const calculatorId = document
        .getElementById("calculator")
        .getAttribute("data-calcid");
      const form = document.querySelector("#calculator");

      if (!form) {
        alert("Calculator form not found.");
        return;
      }

      // Prepare properties object
      const properties = {};
      const inputs = form.querySelectorAll("[name^='properties']");
      let fileInput = form.querySelector("input[type='file']");
      let fileToUpload = null;

      inputs.forEach((input) => {
        const name = input.name.replace("properties[", "").replace("]", "");

        if (input.type === "checkbox") {
          properties[name] = input.checked ? "Checked" : "Unchecked";
        } else if (input.type !== "file") {
          properties[name] = input.value;
        }
      });

      // Handle file upload if present
      if (fileInput && fileInput.files.length > 0) {
        fileToUpload = fileInput.files[0];
      }

      const requestData = {
        calculatorId,
        productId,
        properties,
      };

      try {
        console.log("Apippa API Sent");
        // First create the variant
        const variantRes = await fetch(
          "https://api.custompricecalculator.com/api/v1/variant",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );

        const variantId = await variantRes.json();
        console.log("Variant Id: ", variantId);
        const shopifyVariantId =
          typeof variantId === "string"
            ? variantId
            : variantId?.variantId || variantId?.id;

        if (!shopifyVariantId) throw new Error("Invalid variant ID");

        // Prepare form data for file upload
        const formData = new FormData();
        formData.append("id", shopifyVariantId);
        formData.append("quantity", 1);

        // Add properties
        Object.keys(properties).forEach((key) => {
          formData.append(`properties[${key}]`, properties[key]);
        });

        // Add file if exists
        if (fileToUpload) {
          formData.append(`properties[Upload Image]`, fileToUpload);
        }

        // Add to cart with proper file handling
        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        const cartAddJson = await cartAddRes.json(); // Parse response JSON
        console.log("Add to Cart Response:", cartAddJson);

        localStorage.setItem(
          `patched-cart-item-${cartAddJson.id}`,
          JSON.stringify({
            id: cartAddJson.id,
            title: cartAddJson.product_title,
            image: cartAddJson.image,
            price: cartAddJson.price,
          })
        );

        if (!cartAddRes.ok) throw new Error("Failed to add to cart");

        const cartJson = {
          items: [cartAddJson],
          item_count: 1,
          total_price: cartAddJson.final_price,
          original_total_price: cartAddJson.original_price,
          total_discount: 0,
        };

        // Get mini-cart HTML with cache busting
        const timestamp = new Date().getTime();
        await new Promise((resolve) => setTimeout(resolve, 200)); // slight delay
        const sectionHtml = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`
        ).then((res) => res.text());

        const fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = sectionHtml;
        const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: {
                  ...cartJson,
                  sections: {
                    "mini-cart": miniCartHTML,
                  },
                },
                openMiniCart: true,
              },
            })
          );
        }

        setTimeout(async () => {
          const cartJson = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) {
            cartCountEl.textContent = cartJson.item_count;
          }
        }, 300);

        setTimeout(() => {
          const drawerContent = document.querySelector(
            "#shopify-section-mini-cart .drawer__content"
          );
          if (!drawerContent) return;

          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src =
            "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.setAttribute("style", "width: 300px; height: 300px");
          confetti.setAttribute("direction", "1");
          confetti.setAttribute("playmode", "normal");
          confetti.setAttribute("autoplay", "");

          drawerContent.prepend(confetti);

          setTimeout(() => {
            confetti.remove(); // Only remove the animation, not the cart content
          }, 3000);
        }, 1000);
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = "Add to Cart";
        document.getElementById("back-to-editor").click();
        resetCalculatorForm();
      }
    });
  }

  // **Mutation Observer to watch for calculator form loading**
  const observer = new MutationObserver(() => {
    if (document.querySelector("#calculator")) {
      observer.disconnect();
      document.getElementById("product_loader").classList.remove("loading");
      const variantLoaders = document.querySelectorAll(".variant-loading");
      variantLoaders.forEach((el) => {
        el.classList.remove("variant-loading");
      });
      setupShapeSelection();
      renderSizeOptions();
      setupCustomQuantityInput();
      updateCalculator();
      uploadArtwork();
      setupApippaAddToCart();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
